import React, { cloneElement, Children } from 'react';
import { Anchor } from './Anchor.js';
import 'ricos-schema';

const AddAnchors = ({ addAnchors, children }) => {
  if (addAnchors) {
    const addAnchorsPrefix = addAnchors && (addAnchors === true ? "rcv-block" : addAnchors);
    const firstAnchorKey = `${addAnchorsPrefix}-first`;
    const lastAnchorKey = `${addAnchorsPrefix}-last`;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Anchor, { type: "first", anchorKey: firstAnchorKey }), cloneElement(Children.only(children), { addAnchorsPrefix }), /* @__PURE__ */ React.createElement(Anchor, { type: "last", anchorKey: lastAnchorKey }));
  }
  return children;
};

export { AddAnchors as default };
//# sourceMappingURL=AddAnchors.js.map
